<div class="bodyContainer text-grey">
  <div class="row card-group text-center">
    <nav aria-label="breadcrumb" class="d-flex flex-grow-1">
      <ol class="breadcrumb m-0">
        <li
          class="breadcrumb-item synchpc-primary"
        >Deploy
        </li>
        <li
          class="breadcrumb-item synchpc-primary"
          style="color: black;"
          aria-current="page"
        >{{ infra }}
        </li>
      </ol>
    </nav>
    <div class="my-3 w-20" *ngFor="let provider of cloudProviders">
      <div class="card border-0 text-decoration-none tile row m-0 mb-3 h-100" (click)="addDeployment(provider)" style="cursor: pointer">
        <div class="align-items-center card-header d-flex p-3">
          <div [style.background]="'url(' + provider.providerIconFileName + ')'" class="iconImage">
          </div>
          <div class="ps-3">
            <div class="card-title">{{ provider.providerName }}</div>
            <div class="card-text">{{ provider.providerSubTitle }}</div>
          </div>
        </div>
        <div class="card-body d-flex flex-column">
          <div class="description flex-grow-1">{{ provider.providerDescription }}</div>
          <div class="d-flex flex-row-reverse">
            <!-- <button class="default-btn w-50 mt-4" (click)="addDeployment(provider)">Deploy</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>